<template>
	<div
		class="v-popup v-popup--about"
		body="body"
	>
		<div class="v-popup__inner">
			<div class="v-popup__title">Мы получили Ваше обращение.</div>
			<div class="v-popup__body text-left text">
				Оставайтесь на связи. В ближайшее время священник свяжется с вами по телефону, чтобы подтвердить заявку. <br>  Наш сервис не принимает пожертвований, но мы очень просим делать их при встрече со священником. В это сложное время именно наша лепта является основным доходом для священника и его семьи. Рука дающего да не оскудеет!
			</div>
			<div class="v-popup__buttons text-center">
				<button
						class="btn btn-primary btn"
						@click="close()"
				>
					Хорошо!
				</button>
			</div>
			</div>

			<svgClose class="v-popup__close" @click.native="close()" />
		</div>
</template>

<script>
import svgClose from '../../icons/close'

export default {

	methods: {

		close()
		{
			this.$emit('close')
		},

	},

	components: {
		svgClose,
	},

}
</script>

<style scoped lang="scss">
	.v-popup--about {
		height: 100%;
		height: 100%;
		display: flex;
		max-height: 550px;
		background: white;
		border-radius: 15px;
		display: flex;
		@media (max-width: 567px) {
			max-height: 100%;

		}
	}
.v-popup__inner {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 10000;
}
	.text {
		@media (max-width: 567px) {
			font-size: 12px;
			line-height: 15px;

			color: #18437E;
		}
	}
	.btn {
		@media (max-width: 567px) {
			padding-left: 0;
			padding-right: 0;
			min-width: auto;
			max-width: 220px;
			font-weight: bold;
			font-size: 12px;
			line-height: 15px;
			width: 220px;
		}
	}
</style>
